import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News9ComponentState {
    activeLanguage: string | undefined;
}

const RESULTS: {
    position: number;
    name: string;
    qualified: number;
    rejected: number;
}[] = [
    { position: 1, name: "Gmina Ujazd", qualified: 0, rejected: 1 },
    { position: 2, name: "Gmina Będzinko", qualified: 1, rejected: 1 },
    { position: 3, name: "Gmina Zbąszyń", qualified: 1, rejected: 0 },
    { position: 4, name: "Gmina Kozienice", qualified: 1, rejected: 0 },
    { position: 5, name: "Miasto Rzeszów", qualified: 1, rejected: 1 },
    { position: 6, name: "Gmina Lędziny", qualified: 0, rejected: 1 },
    { position: 7, name: "Gmina Grodków", qualified: 1, rejected: 0 },
    { position: 8, name: "Gmina Czempiń", qualified: 1, rejected: 0 },
    { position: 9, name: "Miasto Rybnik", qualified: 1, rejected: 0 },
    { position: 10, name: "Gmina Jarocin", qualified: 2, rejected: 0 },
    { position: 11, name: "Miasto Nowy Targ", qualified: 1, rejected: 2 },
    { position: 12, name: "Miasto Opole", qualified: 1, rejected: 0 },
    { position: 13, name: "Gmina Garwolin", qualified: 1, rejected: 0 },
    { position: 14, name: "Gmina Krosno", qualified: 1, rejected: 0 },
    { position: 15, name: "Regionalne Centrum Rozwoju i Edukacji (Miasto Lubin)", qualified: 1, rejected: 0 },
    { position: 16, name: "Gmina Rybno", qualified: 1, rejected: 0 },
    { position: 17, name: "Miasto Bydgoszcz", qualified: 0, rejected: 2 },
    { position: 18, name: "Gmina Samborzec", qualified: 1, rejected: 0 },
    { position: 19, name: "Gmina Niegowa", qualified: 0, rejected: 1 },
    { position: 20, name: "Gmina Strzelce Krajeńskie", qualified: 1, rejected: 0 },
    { position: 21, name: "Gmina Czerwin", qualified: 1, rejected: 0 },
    { position: 22, name: "Województwo Podkarpackie", qualified: 2, rejected: 0 },
    { position: 23, name: "Miasto Wisła", qualified: 0, rejected: 1 },
    { position: 24, name: "Gmina Czechowice-Dziedzice", qualified: 1, rejected: 1 },
    { position: 25, name: "Gmina Przasnysz", qualified: 1, rejected: 0 },
    {
        position: 26,
        name: "Związek Gmin i Powiatów Subregionu Północnego Województwa Śląskiego (miasto Częstochowa)",
        qualified: 1,
        rejected: 0,
    },
    { position: 27, name: "Politechnika Rzeszowska (gmina Lesko)", qualified: 1, rejected: 1 },
    { position: 28, name: "GZM (Miasto Bytom, Miasto Zabrze)", qualified: 1, rejected: 0 },
    { position: 29, name: "Gmina i Miasto Lwówek Śląski", qualified: 0, rejected: 1 },
    { position: 30, name: "Gmina Turośń Kościelna", qualified: 1, rejected: 0 },
    { position: 31, name: "Gmina Kisielice", qualified: 1, rejected: 0 },
    { position: 32, name: "Miasto Olsztyn", qualified: 1, rejected: 0 },
    { position: 33, name: "GZM (miasto Katowice, miasto Tychy)", qualified: 1, rejected: 0 },
    { position: 34, name: "Miasto Toruń", qualified: 0, rejected: 2 },
    { position: 35, name: "Gmina Wola Krzysztoporska", qualified: 1, rejected: 0 },
    { position: 36, name: "Miasto Tarnów", qualified: 1, rejected: 0 },
    { position: 37, name: "Gmina Padew Narodowa", qualified: 1, rejected: 0 },
    { position: 38, name: "Powiat Prudnicki", qualified: 0, rejected: 1 },
    { position: 39, name: "Stalowowolska Agencja Rozwoju Regionalnego (Miasto Stalowa Wola)", qualified: 1, rejected: 0 },
];

@Component({
    selector: "dtm-main-page-lib-news-9",
    templateUrl: "./news-9.component.html",
    styleUrls: ["./news-9.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News9Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");
    protected readonly results = RESULTS;
    protected readonly displayedColumns = ["position", "name", "qualified", "rejected", "sum"];
    protected readonly totalQualified = RESULTS.reduce((total, item) => total + item.qualified, 0);
    protected readonly totalRejected = RESULTS.reduce((total, item) => total + item.rejected, 0);
    protected readonly totalSum = this.totalQualified + this.totalRejected;

    constructor(private readonly localStore: LocalComponentStore<News9ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
